import React from "react"
// import { Link, withRouter } from 'react-router'
import { withRouter } from "react-router"
import { apiAuth } from "../../api"
import { FormattedMessage, injectIntl } from "react-intl"
import profileMessages from "../../messages/profile"
import { getStyleTag } from '../../styles/dynamicStyles'

class ConfirmEmail extends React.Component {
  state = {
    loading: true,
    isConfirmed: null,
    user: null,
    errors: {}
  }

  componentDidMount() {
    this.confirmToken()
  }

  confirmToken = () => {
    const {
      intl,
      location: {
        query: { confirmation_token: token }
      }
    } = this.props
    this.setState({ loading: true })

    if (!token) {
      this.setState({
        loading: false,
        errors: { error: intl.formatMessage(profileMessages.invalidToken) }
      })
      return
    }

    apiAuth("POST", `/user/confirm/${token}`)
      .then(user => this.setState({ user }))
      .catch(err => {
        this.setState({
          errors: err.json || {
            error: intl.formatMessage(profileMessages.somethingWentWrong)
          },
          loading: false
        })
      })
  }

  render() {
    const { loading, isConfirmed, errors } = this.state
    return (
      <main id="main" role="main" tabIndex={0} data-componant="Login">
        {getStyleTag('form-message')}
        <div className="row" id="item-info">
          <div className="small-12 columns">
            {isConfirmed && (
              <h1 className="beta mbt">
                <FormattedMessage {...profileMessages.allDone} />
              </h1>
            )}
            {loading && (
              <h1 className="bete mbt">
                <FormattedMessage {...profileMessages.pleaseWait} />
              </h1>
            )}
            {errors.error && (
              <div className="form-message state-error">{errors.error}</div>
            )}
          </div>
        </div>

        <div className="row" id="item-info">
          {/*<div className="small-12 medium-7 columns auth__main-column">*/}
          <div className="small-12 columns auth__main-column" />
        </div>
      </main>
    )
  }
}

export default withRouter(injectIntl(ConfirmEmail))



// WEBPACK FOOTER //
// ./webapp/components/pages/ConfirmEmail.js